export default function handleSearchable(text) {
  let cleaned = text.replace(/[.\-/()]/g, '').replace(/  +/g, ' ').trim()
  const digits = cleaned.replace(/ /g, '')
  if (/^\d+$/.test(digits) && digits.length <= 14)
    return digits
  return cleaned
}
